import React from 'react';
import ProgressLine from '../Partials/ProgressLine/ProgressLine';


const ProgressLinePage = (props) => {
    return (
        <ProgressLine percent={props.percent} />
    );
};
export default ProgressLinePage;
